// extracted by mini-css-extract-plugin
export default {"whatsappFloat":"WhatsApp_whatsappFloat__3Ztd+","waIcon":"WhatsApp_waIcon__ehLcX","waText":"WhatsApp_waText__G2TCa"};